var _a;
import { createSelector } from 'reselect';
import { AppConstant } from 'constants/app.constant';
import { createAction, handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
var initialState = Immutable({
    selectedStudent: {}
});
var prefixActionName = 'EHR';
var restoreState = createAction("".concat(prefixActionName, "/RESTORE"));
var setSelectedStudent = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT"));
var actions = {
    restoreState: restoreState,
    setSelectedStudent: setSelectedStudent
};
var reducer = handleActions((_a = {},
    _a[actions.setSelectedStudent] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudent', payload);
    },
    _a), initialState);
var getEhrState = function (state) { return state[AppConstant.reduxResources.EHR_STATE]; };
var selectors = {
    getSelectedStudent: createSelector(getEhrState, function (state) { return state.selectedStudent; })
};
export { actions as ehrActions, reducer as ehrReducer, selectors as ehrSelectors };
export { initialState as ehrInitialState };
